import { FunctionComponent } from 'react';
import {
  BrowserRouter, Redirect, Route, Switch,
} from 'react-router-dom';
import { ToastProvider } from 'react-toast-notifications';
import { AdminGlobalProvider } from '../contexts';

import { AdminRouteName } from './CONSTANTS';

import Login from './login/Login';
import Transactions from './transactions';
import TransactionDetail from './transactionDetail';
// import Customers from './customers';
import AuthComp from '../AuthComp';
// import PasswordChange from './ResetPassword/PasswordChange';
import CustomerDetail from './customerDetail';
import IdealTimer from '../utils/idealTimer';
import AdminCustomers from './AdminCustomers';
// import AdminLoans from './AdminLoans';
// import AdminRepayments from './AdminRepayment';
// import AdminLoanDetails from './AdminLoanDetails';
// import AdminRepaymentDetails from './AdminRepaymentDetails';
import NotAllowed from './NotAllowed';
import NotFound from './NotFound404';
// import { PreApprovalRentGuarantees, MainRentGuarantees } from './RentGuarantees';
// import AdminGuaranteeDetails from './GuaranteeDetail';
// import Rewards from './Rewards';
// import RewardDetails from './RewardDetails';
// import AdminRentCollectionDetails from './AdminRentCollectionDetails';
// import AdminRentCollection from './AdminRentCollection';
import PasswordReset from './PasswordReset';
import PasswordChange from './PasswordChange';
import AdminSettings from './AdminSettings';
import UserManagementDetails from './AdminSettings/UserManagementDetails';
// import HousingApplication from './HousingApplications';
// import HouseApplicationsDetails from './HousingApplications/HouseApplicationsDetails';
import ProductPreference from './AdminCustomers/ProductPreference';
import ProductAnalysis from './AdminCustomers/ProductAnalysis';
// import BillsPayment from './BillsPayment';

import RealtorTrackingCode from './RealtorTrackingCode';
import RealtorDetails from './RealtorDetails';
import RewardDetails from './RewardDetails';
import Rewards from './Rewards';
import PartnerTrackingCode from './PartnerTrackingCode';
import PartnerCoupons from './PartnerCoupons';
import PartnerDetails from './PartnerDetails';

// import AdminEquifaxReport from './AdminEquifaxReports';
// import BillsPaymentDetails from './BillsPaymentDetails';

const Router: FunctionComponent = () => (
  <ToastProvider>
    <BrowserRouter>
      <AdminGlobalProvider>
        <IdealTimer />
        <AuthComp>
          <div className="">
            <Switch>
              <Route exact path={AdminRouteName.loginRoute} component={Login} />
              <Route
                path={AdminRouteName.forgotPasswordRoute}
                component={PasswordReset}
              />
              <Route
                path={AdminRouteName.passwordChangeRoute}
                component={PasswordChange}
              />
              <Route
                path={AdminRouteName.transactionDetailsRoute}
                component={TransactionDetail}
              />
              <Route
                path={AdminRouteName.transactionRoute}
                component={Transactions}
              />
              {/* <Route
                path={AdminRouteName.billsPaymentDetailsRoute}
                component={BillsPaymentDetails}
              />
              <Route
                path={AdminRouteName.billsPaymentRoute}
                component={BillsPayment}
              /> */}
              <Route
                path={AdminRouteName.notAllowedRoute}
                component={NotAllowed}
              />
              <Route
                path={AdminRouteName.customerDetailsRoute}
                component={CustomerDetail}
              />
              <Route
                path={AdminRouteName.customerProductPreferenceRoute}
                component={ProductPreference}
              />
              <Route
                path={AdminRouteName.customerProductAnalysisRoute}
                component={ProductAnalysis}
              />
              <Redirect
                path={AdminRouteName.customersBaseRoute}
                exact
                to={AdminRouteName.customersRoute}
              />
              <Route
                path={AdminRouteName.customersRoute}
                component={AdminCustomers}
              />
              {/* <Route
                path={AdminRouteName.loanDetailsRoute}
                component={AdminLoanDetails}
              />
              <Route path={AdminRouteName.loansRoute} component={AdminLoans} />
              <Route
                path={AdminRouteName.allPreApprovalGuaranteesRoute}
                component={PreApprovalRentGuarantees}
              /> */}
              {/* <Route
                path={AdminRouteName.allMainGuaranteesRoute}
                component={MainRentGuarantees}
              />
              <Route
                path={AdminRouteName.guaranteeDetailsRoute}
                component={AdminGuaranteeDetails}
              />
              <Route
                path={AdminRouteName.rentCollectionDetailsRoute}
                component={AdminRentCollectionDetails}
              /> */}
              {/* <Route
                path={AdminRouteName.rentCollectionRoute}
                component={AdminRentCollection}
              />
              <Route
                path={AdminRouteName.equifaxReportRoute}
                component={AdminEquifaxReport}
              />
              <Route
                path={AdminRouteName.repaymentDetailsRoute}
                component={AdminRepaymentDetails}
              />
              <Route
                path={AdminRouteName.repaymentsRoute}
                component={AdminRepayments}
              /> */}
              <Route
                path={AdminRouteName.realtorDetailsRoute}
                component={RealtorDetails}
              />
              <Route
                path={AdminRouteName.partnerDetailsRoute}
                component={PartnerDetails}
              />
              <Route
                path={AdminRouteName.rewardDetailsRoute}
                component={RewardDetails}
              />
              <Route
                path={AdminRouteName.rewardStatistics}
                component={Rewards}
              />
              <Route
                path={AdminRouteName.rewardrealtorsTrackingCode}
                component={RealtorTrackingCode}
              />

              <Route
                path={AdminRouteName.rewardpartnersTrackingCode}
                component={PartnerTrackingCode}
              />
              <Route
                path={AdminRouteName.rewardPartnerCoupons}
                component={PartnerCoupons}
              />

              {/* d */}
              <Route
                path={AdminRouteName.settingsTeamMemberDetailsRoute}
                component={UserManagementDetails}
              />
              <Route
                path={AdminRouteName.settingsRoute}
                component={AdminSettings}
              />
              {/* <Route
                path={AdminRouteName.housingApplicationDetailsRoute}
                component={HouseApplicationsDetails}
              />
              <Route
                path={AdminRouteName.housingApplicationRoute}
                component={HousingApplication}
              /> */}
              <Route path={AdminRouteName.notFoundRoute} component={NotFound} />
            </Switch>
          </div>
        </AuthComp>
      </AdminGlobalProvider>
    </BrowserRouter>
  </ToastProvider>
);

export default Router;
